module.exports = __webpack_public_path__ + "img/phone.b027e13f.svg";